"use strict";var $export=require("./_export");$export($export.S,"Math",{sign:require("./_math-sign")});